<template>
  <div>
    <div class="wrapper">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
    <mu-bottom-nav @change="go()" :value.sync="url" class="footer">
      <mu-bottom-nav-item title="安全管理" icon=":icon-icon_statistics iconfont" value="/wap/phoneManageanalysis"></mu-bottom-nav-item>
      <mu-bottom-nav-item title="选择站点" icon=":icon-icon_little_taget iconfont" value="/wap/dashboard"></mu-bottom-nav-item>
    </mu-bottom-nav>
  </div>
</template>
<script>
import { getQueryString } from '@/utils/util'
export default {
  name: 'Layout',
  watch: {
    '$route.path': (newVal) => {
      this.url = newVal
    }
  },
  data () {
    return {
      url: this.$route.path,
      socket: null
    }
  },
  methods: {
    go () {
      this.$router.push(this.url + '?token=' + getQueryString('token'))
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper{
  position: fixed;
  top: 0;
  left: 0;
  height: calc(100% - 53px);
  width: 100%;
  // background: url('../../assets/phoneImg/bg02.jpg') top left/100% 100% no-repeat;
}
.footer{
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #0B2C7B;
  &:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #c0bfc4;
    color: #c0bfc4;
    transform-origin: 0 0;
    transform: scaleY(.5);
  }
}
</style>
<style>
/* @import '../../../static/mui/css/mui.min.css'; */
.iconfont{
  font-family: 'iconfont' !important;
  font-size: 20px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-tiaoshi:before{
  content: '';
  /* background-image: url('../../assets/phoneImg/fh_black@2x.png'); */
  background-size: 100% 100%;
  width: 24px;
  height: 24px;
  display: inline-block;
}
.bold{
  font-weight: bold;
}
.mu-bottom-item{
  color: #fff !important;
}
.mu-bottom-item-active {
  color: #6b97ff  !important;
}
.mu-bottom-item-active .mu-bottom-item-text {
  font-size: 16px !important;
}
.mu-bottom-item-text {
  font-size: 16px !important;
}
.mu-circular-progress.mu-primary-color {
  background: transparent !important;
}
.mu-circle-spinner.mu-primary-color {
  background-color: transparent !important;
}
.mu-primary-color {
  background-color: #4D72C9 !important;
}
.mu-success-color {
  background-color: #4D72C9 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/phoneLayout/index.vue